var ignoreRegexp = /\bmso-list:[^;]*ignore/i;
var idRegexp = /\bmso-list:[^;]*\bl(\d+)/i;
var indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i;
var parseListItem = function parseListItem(element, html) {
  var style = element.getAttribute('style');
  var idMatch = style === null || style === void 0 ? void 0 : style.match(idRegexp);
  if (!idMatch) {
    return null;
  }
  var id = Number(idMatch[1]);
  var indentMatch = style === null || style === void 0 ? void 0 : style.match(indentRegexp);
  var indent = indentMatch ? Number(indentMatch[1]) : 1;
  var typeRegexp = new RegExp("@list l".concat(id, ":level").concat(indent, "\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)"), 'i');
  var typeMatch = html.match(typeRegexp);
  var type = typeMatch && typeMatch[1] === 'bullet' ? 'bullet' : 'ordered';
  return {
    id: id,
    indent: indent,
    type: type,
    element: element
  };
};

// list items are represented as `p` tags with styles like `mso-list: l0 level1` where:
// 1. "0" in "l0" means the list item id;
// 2. "1" in "level1" means the indent level, starting from 1.
var normalizeListItem = function normalizeListItem(doc) {
  var msoList = Array.from(doc.querySelectorAll('[style*=mso-list]'));
  var ignored = [];
  var others = [];
  msoList.forEach(function (node) {
    var shouldIgnore = (node.getAttribute('style') || '').match(ignoreRegexp);
    if (shouldIgnore) {
      ignored.push(node);
    } else {
      others.push(node);
    }
  });

  // Each list item contains a marker wrapped with "mso-list: Ignore".
  ignored.forEach(function (node) {
    var _node$parentNode;
    return (_node$parentNode = node.parentNode) === null || _node$parentNode === void 0 ? void 0 : _node$parentNode.removeChild(node);
  });

  // The list stype is not defined inline with the tag, instead, it's in the
  // style tag so we need to pass the html as a string.
  var html = doc.documentElement.innerHTML;
  var listItems = others.map(function (element) {
    return parseListItem(element, html);
  }).filter(function (parsed) {
    return parsed;
  });
  var _loop = function _loop() {
    var _childListItems$;
    var childListItems = [];
    var current = listItems.shift();
    // Group continuous items into the same group (aka "ul")
    while (current) {
      var _listItems$;
      childListItems.push(current);
      current = listItems.length && ((_listItems$ = listItems[0]) === null || _listItems$ === void 0 ? void 0 : _listItems$.element) === current.element.nextElementSibling &&
      // Different id means the next item doesn't belong to this group.
      listItems[0].id === current.id ? listItems.shift() : null;
    }
    var ul = document.createElement('ul');
    childListItems.forEach(function (listItem) {
      var li = document.createElement('li');
      li.setAttribute('data-list', listItem.type);
      if (listItem.indent > 1) {
        li.setAttribute('class', "ql-indent-".concat(listItem.indent - 1));
      }
      li.innerHTML = listItem.element.innerHTML;
      ul.appendChild(li);
    });
    var element = (_childListItems$ = childListItems[0]) === null || _childListItems$ === void 0 ? void 0 : _childListItems$.element;
    var _ref2 = element !== null && element !== void 0 ? element : {},
      parentNode = _ref2.parentNode;
    if (element) {
      parentNode === null || parentNode === void 0 ? void 0 : parentNode.replaceChild(ul, element);
    }
    childListItems.slice(1).forEach(function (_ref) {
      var e = _ref.element;
      parentNode === null || parentNode === void 0 ? void 0 : parentNode.removeChild(e);
    });
  };
  while (listItems.length) {
    _loop();
  }
};
export default function normalize(doc) {
  if (doc.documentElement.getAttribute('xmlns:w') === 'urn:schemas-microsoft-com:office:word') {
    normalizeListItem(doc);
  }
}